import { z } from "zod";
import {
  CORPORATE_EMAIL_REGEX,
  SectorEnum,
  ShippingTypeEnum,
} from "../constants";
import { SECTOR_EMAILS_LABELS } from "../messages";

export const RecipientFormSchema = z.object({
  sector: z.nativeEnum(SectorEnum, {
    errorMap: () => ({ message: SECTOR_EMAILS_LABELS.SECTOR_REQUIRED }),
  }),
  name: z.string().optional(),
  email: z
    .string()
    .min(1, SECTOR_EMAILS_LABELS.EMAIL_REQUIRED)
    .regex(CORPORATE_EMAIL_REGEX, SECTOR_EMAILS_LABELS.INVALID_DOMAIN),
  shipping_types: z
    .array(z.nativeEnum(ShippingTypeEnum))
    .min(1, SECTOR_EMAILS_LABELS.SHIPPING_TYPES_REQUIRED),
});

export type RecipientFormValues = z.infer<typeof RecipientFormSchema>;
